"use client";

import React from "react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

const variantStyles = {
  capsule:
    "rounded-full bg-yellow-500 hover:bg-yellow-600 text-black font-medium ",
  outline:
    "rounded-full bg-transparent hover:bg-transparent text-yellow-500 border border-yellow-500  transition-colors font-medium",
  default:
    "rounded-md bg-yellow-500 hover:bg-yellow-600 text-black font-medium transition-colors",
  ghost:
    "rounded-lg bg-transparent hover:bg-yellow-500 text-yellow-500 hover:text-black font-medium transition-colors",
};

const sizeStyles = {
  sm: "text-sm px-4 !py-2",
  md: "text-base px-6 !py-3",
  lg: "text-lg px-6 !py-7",
};

interface CustomButtonProps {
  className?: string;
  onClick?: () => void;
  children?: React.ReactNode;
  size?: keyof typeof sizeStyles;
  variant?: keyof typeof variantStyles;
  disabled?: boolean;
  leadingIcon?: React.ReactNode; // Optional icon/image before text
}

export default function CustomButton({
  className = "",
  onClick,
  children,
  size = "lg",
  variant = "capsule",
  disabled = false,
  leadingIcon,
}: CustomButtonProps): JSX.Element {
  return (
    <Button
      onClick={onClick}
      disabled={disabled}
      className={cn(
        "inline-flex font-outfit items-center gap-2",
        variantStyles[variant],
        sizeStyles[size],
        className
      )}
    >
      {leadingIcon && <span className="flex-shrink-0">{leadingIcon}</span>}
      {children && <span className="font-inter font-normal"> {children}</span>}
    </Button>
  );
}
